import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { Section } from "@/components/Section";
import { KeyIdea } from "@/components/Callouts";

export default function EdSheeran2() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "2");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section title="Chord Chart">
        <NoteImage
          src="/notes/ed-sheeran/finals/02-sapphire.png"
          caption="Jason's chord chart for Sapphire"
        />
      </Section>

      <Section title="Pre-Chorus Harmony">
        <RomanNumeralAnalysis
          label="Pre-chorus · D♭ major"
          chords={[
            { chord: "Db", rn: "I", function: "Tonic", pitches: ["Db3", "F3", "Ab3", "Db4"] },
            { chord: "Ebm7", rn: "ii7", function: "Pre-dominant", pitches: ["Eb3", "Gb3", "Bb3", "Db4"] },
            { bar: true },
            { chord: "Bbm", rn: "vi", function: "Submediant", pitches: ["Bb2", "Db3", "F3", "Bb3"] },
            { chord: "F#", rn: "IV", function: "Pre-dominant", pitches: ["F#2", "A#2", "C#3", "F#3"] },
          ]}
        />
        <KeyIdea title="Every chord is in the key">
          E♭m7 (E♭–G♭–B♭–D♭) is the ii7 chord of D♭ major. Jason writes the last chord as F♯ — in
          D♭ major that is the IV chord, G♭ (the same keys on the piano). So I–ii7–vi–IV never
          leaves D♭ major. In the chorus the same loop returns, and Jason colours the IV chord as
          F♯add9.
        </KeyIdea>
      </Section>

      <Section title="Watch">
        <YouTubeEmbed videoId="JgDNFQ2RaLQ" />
      </Section>
    </LessonShell>
  );
}
